<template>
  <div class="min-h-screen bg-gray-100 p-2">
    <div class="bg-gray-800 text-white rounded-lg p-3 mb-3 shadow-lg">
      <div class="flex flex-wrap col-span-4 justify-between items-center gap-2">
        <div class="mr-2">
          <span class="text-xs">تاریخ تحویل:
          </span>
          <span class="font-semibold text-indigo-300 text-md">
            {{ deliver.delivery_date }}
          </span>
        </div>
        <div>
        <span class="text-xs">راننده:
        </span>
          <span class="font-semibold text-indigo-300 text-md">
            {{ deliver.driver_name }}
          </span>
        </div>
        <div>
                <span class="text-xs">شماره سند:
                </span>
          <span class="font-semibold text-indigo-300 text-md">
            {{ deliver.document_number }}
          </span>

        </div>
        <div class="ml-2">
        <span class="text-xs">تعداد جعبه:

          </span>
          <span class="font-semibold text-indigo-300 text-md">
            {{ deliver.total_boxes }}
          </span>

        </div>

      </div>
    </div>

    <!-- اطلاعات بسته بندی -->
    <div class="bg-white rounded-lg shadow-md p-3 mb-3">
      <h3 class="text-lg font-bold border-b pb-2 mb-2">اطلاعات بسته</h3>
      <div class="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-2 text-xs">
        <div>
          <p class="text-gray-500">عنوان</p>
          <p class="font-medium">{{ deliver.package.title }}</p>
        </div>
        <div>
          <p class="text-gray-500">شماره فاکتور</p>
          <p class="font-medium">{{ deliver.package.factor_number }}</p>
        </div>
        <div class="flex items-center space-x-2">
          <div class="relative">
            <select
                v-model="deliver.package.supplier"
                class="w-44 appearance-none px-3 py-1.5 pr-2 bg-gray-800 text-white border border-gray-300 rounded-lg text-xs shadow-sm focus:ring-2 focus:ring-blue-400 focus:border-blue-400 text-right cursor-pointer"
            >
              <option :value="null">بدون تامین کننده</option>
              <option
                  v-for="supplier in suppliers"
                  :key="supplier.id"
                  :value="supplier.id"
              >
                {{ supplier.name }}
              </option>
            </select>
            <svg
                class="w-3 h-3 absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                viewBox="0 0 24 24"
            >
              <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7"/>
            </svg>
          </div>
        </div>

        <div>
          <p class="text-gray-500">هزینه حمل</p>
          <p class="font-medium">{{ deliver.package.cargo_cost_per_shipping.toLocaleString() }}</p>
        </div>
      </div>
    </div>

    <!-- جدول آیتم‌ها -->
    <div class="bg-white rounded-lg shadow-md overflow-hidden">
      <h3 class="text-lg font-bold p-3 border-b">آیتم های تحویل</h3>
      <div class="space-y-4 p-4  mx-auto">
        <div
            v-for="(item, index) in deliver.items"
            :key="item.id"
            class="bg-gray-800 border border-gray-600 rounded-xl shadow-md overflow-hidden transition-all duration-300 hover:shadow-lg"
            role="region"
            :aria-expanded="item.expanded"
            :aria-label="`آیتم ${item.product_name || 'بدون نام'}`"
        >
          <!-- Header for expandable card -->
          <button
              @click="toggleExpanded(index)"
              class="w-full px-5 py-4 flex items-center justify-between bg-gray-700 hover:bg-gray-600 transition-colors text-right focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <div class="flex items-center flex-1">
              <!-- Image -->
              <img
                  v-if="item.package_item.image"
                  :src="img_source(item.package_item.image)"
                  class="h-10 w-10 max-w-md object-cover rounded-full ml-4"
                  alt="تصویر محصول"
              />
              <span class="text-base font-semibold text-white ml-4 truncate">{{
                  item.product_name || 'بدون نام'
                }}</span>
              <span
                  class="px-3 py-1 rounded-full text-sm font-medium ml-4"
                  :class="{
              'bg-green-600/20 text-green-300 border border-green-600/30': item.verified,
              'bg-yellow-600/20 text-yellow-300 border border-yellow-600/30': !item.verified
            }"
              >
            {{ item.verified ? 'تأیید شده' : 'در انتظار تأیید' }}
          </span>
            </div>
            <!-- Expand/Collapse Icon -->
            <i
                class="fas fa-chevron-down text-gray-300 text-lg transition-transform duration-300"
                :class="{ 'rotate-180': item.expanded }"
            ></i>
          </button>

          <!-- Expandable Content -->
          <transition name="expand">
            <div v-show="item.expanded" class="px-6 py-5 bg-gray-800 border-t border-gray-600">
              <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                <!-- Column 1 -->
                <div class="space-y-5">
                  <div v-if="!item.verified">
                    <div>
                      <label class="block text-sm font-medium text-gray-200 mb-2">نام محصول</label>
                      <input
                          type="text"
                          v-model="item.product_name"
                          class="w-full px-4 py-2 bg-gray-700 text-white border border-gray-600 rounded-lg text-sm focus:ring-2 focus:ring-blue-400 focus:border-blue-400 transition-colors"
                          placeholder="نام محصول را وارد کنید"
                          aria-label="نام محصول"
                      />
                    </div>
                    <div v-if="item.product">
                      <label class="block text-sm font-medium text-green-200 mb-2"> محصول موجود</label>
                      <products-select v-model="item.product" :preset-items="allProducts" :lazy="item.product == null"
                      ></products-select>
                    </div>

                    <div v-else>
                      <label class="block text-sm font-medium text-red-500 mb-2"> انتخاب محصول در صورت وجود </label>
                      <products-select v-model="item.product"
                                       :disabled="item.verified" :preset-items="allProducts" :lazy="item.product == null"
                      ></products-select>
                    </div>
                  </div>
                  <div v-else>
                    <div>
                      <label class="block text-sm font-medium text-gray-200 mb-2">نام محصول</label>

                      <span
                          type="text"
                          @click="seeProduct(item)"
                          class="w-full mt-1 cursor-pointer w-full px-4 py-2 bg-gray-700 text-white border border-gray-600 rounded-lg text-sm focus:ring-2 focus:ring-blue-400 focus:border-blue-400 transition-colors"
                      >{{item.product_name }}</span>
                    </div>
                  </div>

                  <!-- SKU -->
                  <div>
                    <label class="block text-sm font-medium text-gray-200 mb-2">SKU</label>
                    <div class="px-4 py-2 bg-gray-700 rounded-lg text-sm text-gray-300">
                      {{ item.sku || 'بدون SKU' }}
                    </div>
                  </div>

                  <!-- Group ID -->
                  <div>
                    <label class="block text-sm font-medium text-gray-200 mb-2">کد محصول</label>
                    <div class="px-4 py-2 bg-gray-700 rounded-lg text-sm text-gray-300">
                      {{ item.group_id || 'بدون کد' }}
                    </div>
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-200 mb-2">تعداد</label>
                    <div class="px-4 py-2 bg-gray-700 rounded-lg text-sm text-gray-300">
                      {{ item.total_quantity || 0 }} عدد
                    </div>
                  </div>

                  <!-- Crashed Quantity -->
                  <div>
                    <label class="block text-sm font-medium text-gray-200 mb-2">وضعیت شکستگی</label>
                    <span
                        class="inline-block px-4 py-2 bg-gray-700 rounded-lg text-sm"
                        :class="{
                    'text-red-300 border border-red-600/30': item.crashed_quantity > 0,
                    'text-gray-300 border border-gray-600/30': item.crashed_quantity === 0
                  }"
                    >
                  {{ item.crashed_quantity > 0 ? item.crashed_quantity + ' شکسته' : 'سالم' }}
                </span>
                  </div>
                </div>

                <!-- Column 2 -->
                <div class="space-y-5">
                  <div>
                    <label class="block text-sm font-medium text-gray-200 mb-2">
                      قیمت مصرف کننده
                    </label>
                    <div class="px-4 py-2 bg-gray-700 rounded-lg text-sm text-white" >
                      {{ item.package_item.regular_price | toMoney(0)}}
                    </div>
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-200 mb-2">
                      قیمت پایه
                    </label>
                    <div class="px-4 py-2 bg-gray-700 rounded-lg text-sm text-white" >
                      {{ item.package_item.price | toMoney(0)}}
                    </div>
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-200 mb-2"> شکستگی در این پکینگ</label>
                    <div class="px-4 py-2 bg-gray-700 rounded-lg text-sm text-red-300">
                      {{ item.package_item.total_crashed_items | toMoney}}
                    </div>
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-200 mb-2">قیمت پایه با محاسبه شکستگی  </label>
                    <input
                        :disabled="item.verified"
                        type="number"
                        v-model="item.package_item.price_after_crash"
                        class="w-full px-4 py-2 bg-gray-700 text-white border text-blue-300 border-gray-600 rounded-lg text-sm focus:ring-2 focus:ring-blue-400 focus:border-blue-400 transition-colors"
                        placeholder="0"
                        min="0"
                        aria-label="قیمت پایه با محاسبه شکستگی"
                    />
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-200 mb-2">نوع سود</label>
                    <div class="relative">
                      <select
                          :disabled="item.verified"
                          v-model="item.package_item.profit_type"
                          @change="updateFinalAmount(item)"
                          class="w-full px-4 py-2 bg-gray-700 text-white border border-gray-600 rounded-lg text-sm focus:ring-2 focus:ring-blue-400 focus:border-blue-400 appearance-none pr-10"
                          aria-label="نوع سود"
                      >
                        <option value="">بدون نوع</option>
                        <option value="percent">درصد</option>
                        <option value="amount">مبلغ</option>
                      </select>
                      <i class="fas fa-chevron-down absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"></i>
                    </div>
                  </div>

                  <!-- Profit Margin -->
                  <div>
                    <label class="block text-sm font-medium text-gray-200 mb-2">سود</label>
                    <div class="relative">
                      <input
                          :disabled="item.verified"
                          type="number"
                          :value="item.package_item.profit_margin"
                          @input="updateProfitMargin(item, $event.target.value)"
                          class="w-full px-4 py-2 bg-gray-700 text-white border border-gray-600 rounded-lg text-sm focus:ring-2 focus:ring-blue-400 focus:border-blue-400 transition-colors "
                          placeholder="0"
                          min="0"
                          aria-label="سود"
                      />
                      <span
                          class="absolute left-3 top-5 transform -translate-y-1/2 text-gray-400 text-sm"
                          :class="{ 'text-orange-300': item.package_item.profit_type }">
                        {{
                          item.package_item.profit_type === 'percent' ? '%' : item.package_item.profit_type === 'amount' ? 'تومان' : ''
                        }}
                      </span>
                    </div>
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-200 mb-2">قیمت (تومان)</label>
                    <div class="px-4 py-2 bg-gray-700 rounded-lg text-sm text-gray-300">
                      {{ item.package_item.final_amount | toMoney(0) }}
                    </div>
                  </div>

                  <!-- Shipping Cost -->
                  <div>
                    <label class="block text-sm font-medium text-gray-200 mb-2">هزینه ارسال</label>
                    <div class="px-4 py-2 bg-gray-700 rounded-lg text-sm text-gray-300">
                      {{ item.average_cargo_cost_per_item | toMoney(0) }}
                    </div>
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-200 mb-2">در صورت فروش تومان</label>
                    <div class="px-4 py-2 bg-gray-700 rounded-lg text-sm text-gray-300" v-if="!item.verified">

                      {{
                        Math.ceil((item.package_item.final_amount + (item.average_cargo_cost_per_item || 0)) / 100) * 100
                            | toMoney(0)
                      }}
                    </div>
                    <div class="px-4 py-2 bg-gray-700 rounded-lg text-sm text-gray-300" v-else>
                      {{ item.package_item.sale_price | toMoney}}

                    </div>
                  </div>
                </div>
              </div>

              <!-- Third Row for Remaining Fields -->
              <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
                <!-- Minimum Inventory -->
                <div>
                  <label class="block text-sm font-medium text-gray-200 mb-2">حداقل موجودی</label>
                  <input
                      :disabled="item.verified"
                      type="number"
                      v-model="item.min_inventory"
                      class="w-full px-4 py-2 bg-gray-700 text-white border border-gray-600 rounded-lg text-sm focus:ring-2 focus:ring-blue-400 focus:border-blue-400 transition-colors"
                      placeholder="0"
                      min="0"
                      aria-label="حداقل موجودی"
                  />
                </div>

                <!-- To Store -->
                <div>
                  <label class="block text-sm font-medium text-gray-200 mb-2">به انبار</label>
                  <div class="relative">
                    <select
                        :disabled="item.verified"
                        v-model="item.to_store"
                        class="w-full px-4 py-2 bg-gray-700 text-white border border-gray-600 rounded-lg text-sm focus:ring-2 focus:ring-blue-400 focus:border-blue-400 appearance-none pr-10"
                        aria-label="انبار مقصد"
                    >
                      <option value="">بدون انبار</option>
                      <option v-for="store in stores" :key="store.id" :value="store.id">
                        {{ store.name }}
                      </option>
                    </select>
                    <i class="fas fa-chevron-down absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"></i>
                  </div>
                </div>

                <!-- Verify Button -->
                <div>
                  <label class="block text-sm font-medium text-gray-200 mb-2">
                    {{ item.verified ? 'وضعیت' : 'آیا تایید میکنید؟' }}
                  </label>
                  <button
                      v-if="!item.verified"
                      @click="verifyItem(item)"
                      class="w-full px-4 py-2 bg-blue-600 text-white rounded-lg text-sm hover:bg-blue-700 transition-colors flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed"
                      :disabled="isVerifyDisabled(item)"
                      aria-label="تأیید آیتم"
                  >
                    <i class="fas fa-check-circle ml-2"></i>
                    تأیید آیتم
                  </button>
                  <div
                      v-else
                      class="px-4 py-2 bg-green-600/20 text-green-300 border border-green-600/30 rounded-lg text-sm flex items-center justify-center"
                  >
                    <i class="fas fa-check-circle ml-2"></i>
                    تأیید شده
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
    <transition name="slide-fade">
      <div v-if="showNotification"
           class="fixed bottom-4 right-4 z-50 flex items-center p-4 w-[90%] max-w-xs text-gray-100 bg-gray-900 rounded-lg shadow-lg border border-gray-700">

        <div
            class="inline-flex items-center justify-center flex-shrink-0 w-8 h-8 rounded-lg text-green-400 bg-gray-800">
          <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clip-rule="evenodd"/>
          </svg>
        </div>

        <div class="mr-3 text-sm font-normal pr-2">تایید شد</div>

        <button @click="showNotification = false"
                class="mr-auto text-gray-400 hover:text-white rounded-lg p-1.5 hover:bg-gray-800">
          <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clip-rule="evenodd"/>
          </svg>
        </button>
      </div>
    </transition>

  </div>
</template>
<script>

import ProductsSelect from "@/components/selects/ProductSelect";

export default {
  name: 'DomesticDeliverInsertedWaitForVerify.vue',
  components: {ProductsSelect},
  props: {
    id: {},
  },
  data() {
    return {
      isLoading: false,
      deliver: {},
      showNotification: false,
      stores: [],
      suppliers: [],
    }
  },
  methods: {
    seeProduct(item) {
      console.log(item.product)
      this.$router.push(`/panel/adminProductForm/${item.product}`)
    },
    showNotificationMessage() {
      this.showNotification = true;
      setTimeout(() => {
        this.showNotification = false;
      }, 5000);
    },

    verifyDeliver(id) {
      const item = this.insert_items[id];
      if (!item.min_inventory || !item.to_store || !item.sku) {
        window.alert(`اطلاعات  sku ، حداقل موجودی و انبار  اجباری می باشد`)
        return
      }

      this.isLoading = true
      this.request({
        url: this.endpoint(`entrance/deliveriesItem/insert/${id}`),
        method: 'put',
        data: this.insert_items[id],
        success: (data) => {
          this.isLoading = false
          this.showNotificationMessage()
          this.fetchPacking()
        },
        error: (error) => {
          window.alert(error)
          this.isLoading = false
        }
      })
    },
    fetchDeliver() {
      this.isLoading = true

      this.request({
        url: this.endpoint(`entrance/verifyDomesticEntrancePackageDelivery/${this.id}`),
        method: 'get',
        success: (data) => {
          this.deliver = data
          this.isLoading = false
          this.deliver.items = this.deliver.items.map(item => ({
            ...item,
            expanded: false
          }))
        },
        error: () => {
          this.isLoading = false
        }
      })
    },

    updateProfitMargin(item, value) {
      const number = parseFloat(value) || 0;
      this.$set(item.package_item, 'profit_margin', number);

      this.updateFinalAmount(item);
    },
    updateFinalAmount(item) {
      let basePrice = parseFloat(item.package_item.price_after_crash) || 0;
      let profit = 0;

      if (item.package_item.profit_type === 'percent') {
        profit = basePrice * (item.package_item.profit_margin / 100);
      } else if (item.package_item.profit_type === 'amount') {
        profit = item.package_item.profit_margin;
      }

      const finalAmount = basePrice + profit;
      this.$set(item.package_item, 'final_amount', finalAmount);

    },
    refreshDeliver() {
      this.fetchDeliver()
    },

    fetchStores() {
      this.request({
        url: this.endpoint(`main/store`),
        method: "get",
        success: data => {
          this.stores = data
          console.log(this.stores)
        }
      })
    },
    fetchSuppliers() {
      this.request({
        url: this.endpoint('main/supplier'),
        method: 'get',
        success: (data) => {
          this.suppliers = data
        }
      })
    },
    toggleExpanded(index) {
      this.$set(this.deliver.items[index], 'expanded', !this.deliver.items[index].expanded)
    },
    verifyItem(item) {
      this.isLoading = true
      this.request({
        url: this.endpoint(`entrance/verifyDomesticEntrancePackageDeliveryItem/${item.id}`),
        method: 'put',
        data: item,
        success: (data) => {
          this.isLoading = false
          this.showNotificationMessage()
          this.fetchDeliver()
        },
        error: (error) => {
          window.alert(error)
          this.isLoading = false
        }
      })
    },
    isVerifyDisabled(item) {
      return !item.product_name || !item.package_item.price || !item.to_store
    }


  },
  created() {
    this.fetchStores()
    this.fetchSuppliers()
    this.fetchDeliver()
  }
}
</script>

<style scoped>
/* Expand transition */
.expand-enter-active,
.expand-leave-active {
  transition: max-height 0.4s ease-in-out, opacity 0.4s ease-in-out;
  overflow: hidden;
}

.expand-enter,
.expand-leave-to {
  max-height: 0;
  opacity: 0;
}

.expand-enter-to,
.expand-leave {
  max-height: 1200px; /* Adjust based on content height */
  opacity: 1;
}

/* Input and select text alignment */
input,
select {
  text-align: right;
}

/* Hover and focus effects */
button:hover,
input:focus,
select:focus {
  outline: none;
}

/* Custom scrollbar for long content */
div[role="region"]::-webkit-scrollbar {
  width: 6px;
}

div[role="region"]::-webkit-scrollbar-track {
  background: #374151;
  border-radius: 3px;
}

div[role="region"]::-webkit-scrollbar-thumb {
  background: #6b7280;
  border-radius: 3px;
}

div[role="region"]::-webkit-scrollbar-thumb:hover {
  background: #9ca3af;
}

/* Responsive grid */
@media (max-width: 768px) {
  .md\:grid-cols-2 {
    grid-template-columns: 1fr;
  }

  .md\:grid-cols-3 {
    grid-template-columns: 1fr;
  }
}
</style>